import React from 'react';
import Chart from 'react-apexcharts';
import { Card, CardContent } from '@material-ui/core';
import moment from 'moment';

function MemoryUsage({ classes, data, samples }) {
  const buildDataset = data => {
    return {
      options: {
        chart: {
          animations: {
            enabled: true,
            easing: 'easein',
            speed: 120,
            animateGradually: {
              enabled: true,
              delay: 250
            },
            dynamicAnimation: {
              enabled: true,
              speed: 80
            }
          },
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          offsetX: -10
        },
        // markers: {
        //   size: [3, 3, 3]
        // },
        // noData: {
        //   align: 'left'
        // },
        // subtitle: {
        //   text: '',
        //   offsetX: 5,
        //   offsetY: 18
        // },
        title: {
          text: 'Memory Usage (in GB)'
        },
        xaxis: {
          type: 'datetime',
          range: 120000,
          labels: {
            rotate: -30,
            rotateAlways: true,
            formatter: function(val, timestamp) {
              // hh:mm:ss a
              return moment(new Date(timestamp)).format('hh:mm:ss');
            }
          }
        },
        yaxis: {
          decimalsInFloat: 2,
          min: 0,
          max: Math.min(
            (data['heap.maximum'] / (1024 * 1024 * 1024)) * 1.1,
            60.0
          )
        }
      },
      series: samples.series
    };
  };

  const dataset = buildDataset(data);
  return (
    <Card>
      <CardContent className={classes.lineChartContainer}>
        <Chart
          options={dataset.options}
          series={dataset.series}
          type="area"
          width="100%"
          height="320"
        />
      </CardContent>
    </Card>
  );
}

export default MemoryUsage;
